/* @flow */

import React from 'react'
import i18n from 'atpjs/helpers/i18n'
import Step from 'tve/views/step'
import Application from 'tve/components/application'

const t = i18n.prefix(['cancelled'])

class Cancelled extends Step {
  sendData = false

  render() {
    // const inputSetProps = this.inputSetProps()

    return (
      <Application title={t(['title'])} name={i18n.trans(['tve', 'title'])}>
        <p>{t(['content'])}</p>
      </Application>
    )
  }
}

export default Cancelled
